import React from "react";
import { withStyles, Typography } from "@material-ui/core";
import clsx from "clsx";

const styles = theme => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wardRequestText: {
    color: theme.palette.primary.main, // blue color
    fontWeight: "bold",
    fontSize: "2rem",
  },
});

function WardRequestStatus(props) {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <Typography className={clsx(classes.wardRequestText)}>
        Ward Request
      </Typography>
    </div>
  );
}

export default withStyles(styles)(WardRequestStatus);
